import { StatusReserveAccount } from 'Pages/orders_design/models/common/StatusReserveAccount'

export enum ReserveAccountStatus {
	draft = 'draft',
	reservation = 'reservation',
	status_reservation = 'status_reservation',
	reservation_error = 'reservation_error',
	rejected_reservation = 'rejected_reservation',
	completed = 'completed',
}

export const disableInfoBlockStatuses = [StatusReserveAccount.IN_WORK, StatusReserveAccount.LATER]

export const finalReserveStatuses = [
	ReserveAccountStatus.reservation_error,
	ReserveAccountStatus.completed,
	ReserveAccountStatus.rejected_reservation,
]

export const errorReserveStatuses = [
	ReserveAccountStatus.reservation_error,
	ReserveAccountStatus.rejected_reservation,
]

export const outOfficeDisplayStatuses = [ReserveAccountStatus.completed]
